import React, { FC } from 'react';
import { QuickQuoteAvgTimeProps } from './QuickQuoteTypes';

export const QuickQuoteAvgTime: FC<QuickQuoteAvgTimeProps> = ({
  timeToComplete,
  time,
  timeUnit,
  quickQuoteLabel,
  quickQuoteDescription,
  quickQuoteBoldDescription,
  className = ''
}) => (
  <div className="quote-label">
    <div className={`avg-time d-flex flex-row my-3 ${className}`}>
      <div className="d-flex flex-column justify-content-center left-box alt-primary-semi-dark-bg">
        <div>{timeToComplete}</div>
        <div className="d-flex flex-row align-items-end">
          <span className="time-unit">{time}</span>
          <span>{timeUnit}</span>
        </div>
      </div>
      <div className="d-flex flex-column">
        <h2 className="p-0">{quickQuoteLabel}</h2>
        <small className="">{quickQuoteDescription}</small>
      </div>
    </div>
    <b className="my-auto bold-label">{quickQuoteBoldDescription}</b>
  </div>
);
QuickQuoteAvgTime.displayName = 'QuickQuoteAvgTime';
export default QuickQuoteAvgTime;
